<template>
  <div class="header">
    <logos></logos>
    <header-title
      @click.native="openTopMenu()"
      @setactivemenu="navigateBottomMenu"
      :titleState="headerTopLine"
      :choosenMenuName="choosenMenuName"
    ></header-title>
    <header-subtitle
      v-if="needHeaderSubtitle()"
      @click.native="openBottomMenu()"
      :subtitleState="headerBottomLine"
      :choosenSubmenuItems="this.$store.state.choosenMobileSubmenuItems"
    ></header-subtitle>
  </div>
</template>

<script>
import Logos from '@/components/Logo/Logos';
import HeaderTitle from '@/components/ContentHeader/HeaderTitle/HeaderTitle';
import HeaderSubtitle from '@/components/ContentHeader/HeaderSubtitle/HeaderSubtitle';
import Clicks from '@/components/ContentHeader/mixins/clicks';
import { psoriasis as psoriasisSections } from '@/data/sections';
import { tremfya as tremfyaSections } from '@/data/sections';

export default {
  data() {
    return {
      headerTopLine: 'basic',
      headerBottomLine: 'basic',
      choosenMenuName: '',
      choosenSubmenuItems: []
    };
  },
  mixins: [Clicks],
  components: {
    Logos,
    'header-title': HeaderTitle,
    'header-subtitle': HeaderSubtitle
  },
  name: 'content-header',
  watch: {
    '$store.state.headerStatus'(val) {
      if (val === 'basic') {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      }
    },
    $route() {
      if (this.$store.state.headerStatus === 'openSubmenu') {
        this.headerTopLine = 'basic';
        this.headerBottomLine = 'basic';
      }
    },
    headerState: {
      handler: function(newValue) {
        if (newValue === 'basic-large,menu-auto') {
          this.$store.commit('setHeaderStatus', 'openSubmenu');
          return;
        }
        if (newValue !== 'basic,basic') {
          this.$store.commit('setHeaderStatus', 'menu');
          return;
        }
        this.$store.commit('setHeaderStatus', 'basic');
      },
      immediate: true
    }
  },
  methods: {
    needHeaderSubtitle() {
      // console.log('needHeaderSubtitle()');
      if (
        this.$route.meta.page === 'Tremfya' &&
        (this.$store.state.currentMobileSubmenu === '4' ||
          this.$store.state.currentMobileSubmenu === '5')
      ) {
        return false;
      }
      return true;
    }
  },
  computed: {
    headerState() {
      return [this.headerTopLine, this.headerBottomLine].join(',');
    },
    sections() {
      if (this.$route.meta.page === 'Psoriasis') {
        return psoriasisSections;
      } else if (this.$route.meta.page === 'Tremfya') {
        return tremfyaSections;
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" src="./ContentHeader.scss">
</style>
